module.exports = "pegasus/assets/blocks/column-7-theme2.png";